export const environment = {
  production: true,
  paginationSize: 2000,
  url: "https://i4y-notifier.ew.r.appspot.com/"
  //url: "http://localhost:8090/"
};
